var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "error-feedback" }, [
    _c(
      "svg",
      {
        attrs: {
          width: "14",
          height: "14",
          viewBox: "0 0 14 14",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      [
        _c("circle", {
          attrs: {
            cx: "7",
            cy: "7",
            r: "6.5",
            fill: "white",
            stroke: "#FF238D",
          },
        }),
        _c("circle", { attrs: { cx: "7", cy: "10", r: "1", fill: "#FF238D" } }),
        _c("rect", {
          attrs: {
            x: "6",
            y: "3",
            width: "2",
            height: "5",
            rx: "1",
            fill: "#FF238D",
          },
        }),
      ]
    ),
    _c("div", { staticClass: "error-feedback__text" }, [
      _vm._v(" " + _vm._s(_vm.text) + " "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }